module.exports = __webpack_public_path__ + "static/media/Jazz Musician.48e49e8d.jpg";